import { Send } from "lucide-react";
import { useState } from "react";
import { useTranslate } from "../../../locales/hooks";

type ComposerProps = {
  onSend?: (message: string) => void;
  disabled?: boolean;
};

const Composer: React.FC<ComposerProps> = ({
  onSend,
  disabled = false,
}: ComposerProps) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    if (message.trim() && !disabled && onSend) {
      onSend(message);
      setMessage("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const t = useTranslate();

  return (
    <div
      className="relative shrink-0 w-full border-t border-[#ddd] bg-white"
      data-name="composer"
    >
      <div className="content-stretch flex flex-col gap-[8px] px-[20px] py-[15px] relative w-full">
        {/* Helper text */}
        <p className="hidden md:flex font-['Manrope:Regular',sans-serif] font-normal leading-[1.4] text-[#717182] text-[10px]">
          {t("composer__tipDescription")}
        </p>

        {/* Input area */}
        <div className="flex items-end gap-[10px] w-full">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={disabled}
            placeholder={t("composer__tipText")}
            className="flex-1 min-h-[80px] max-h-[200px] px-[14px] py-[10px] bg-[#f8fafc] border border-[#ddd] rounded-[10px] font-['Manrope:Regular',sans-serif] font-normal text-[14px] text-[#0f172a] placeholder:text-[#717182] resize-none focus:outline-none focus:ring-2 focus:ring-[#334155] focus:ring-opacity-20 disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ lineHeight: "1.5" }}
          />
          <button
            onClick={handleSend}
            disabled={disabled || !message.trim()}
            className="self-center flex items-center justify-center p-[10px] bg-[#0f172a] rounded-[10px] hover:bg-[#334155] transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#0f172a]"
          >
            <Send className="w-[20px] h-[20px] text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Composer;
